import gql from "graphql-tag";

export const NUTRITION_BLOCKS_QUERY = gql`
  query nutritionBlocks {
    nutritionBlocks(isActive: true) {
      edges {
        node {
          id
          title
          activeUsers
          completedUsers
        }
      }
    }
  }
`;

export const COACHING_NUTRITION_BLOCK_MUTATION = gql`
  mutation coachingSubscriptionNutritionBlockMutation($input: UserSubscriptionBlockInput!) {
    coachingSubscriptionNutritionBlockMutation(data: $input) {
      error
      success
    }
  }
`;

export const SUBSCRIPTION_NUTRITION_BLOCK_QUERY = gql`
  query nutritionSubscriptionBlock($subscriptionBlockId: ID!) {
    nutritionSubscriptionBlock(id: $subscriptionBlockId) {
      id
      startDate
      originalStartDate
      nutritionBlock {
        id
        title
      }
    }
  }
`;
